import qs from 'qs'
import axios from 'axios'


const Headers = {
    'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    'Access-Control-Allow-Origin': "*"
}

axios.interceptors.request.use( (request) => {
    const token = localStorage.getItem('token');
    if ( token )
    {
        request.headers.Authorization = `Bearer ${token}`;
    }
    else{
        request.headers.Authorization = '';
    }

    return request;
}, error => {
    return Promise.reject(error);
} );

axios.interceptors.response.use( 
    (response) => response,
    error => {
        return Promise.reject(error);
    }
);

export const apiCall = ( method, url, data, headers = Headers ) => axios({
    method,
    url,
    data: qs.stringify({
        ...data
    }),
    headers
})


export const apiPdf = ( method, url, data, headers = Headers ) => axios({
    method,
    url,
    data: qs.stringify({
        ...data
    }),
    responseType: 'arraybuffer',
    headers
})




// export const client = (token = null) => {
//     const defaultOptions = {
//         headers: {
//             Authorization: token ? `Bearer ${token}` : '',
//             'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
//             'Access-Control-Allow-Origin': "*"
//         },
//     };

//     return {
//         call: ( method, url, data, headers = { ...defaultOptions } ) => axios({
//             method,
//             url,
//             data: qs.stringify({
//                 ...data
//             }),
//             headers
//         })
//     };
// };
